import { Injectable } from "@angular/core";
import { WindowService } from "../window/window-service";
import { Ecommerce, GA4View, GABegin, GAStepDetails, PageEventDetails } from "./ga.models";
import { GAPageMapping } from "./ga-page-mapping";
import { GACardMapping } from "./ga-card-mapping";
import { ProductService } from "../product.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root"
})
export class RbcTagManagerService {
  get href(): string {
    return this.window.nativeWindow.location.href;
  }

  constructor(
    private window: WindowService,
    private productService: ProductService,
    private translateService: TranslateService
  ) {}

  getLob(): string {
    return this.productService.chnl.toLowerCase() === "ccpa" ? "credit cards" : "bfs";
  }

  defaultProps = () => {
    return {
      lob: this.getLob(), // bfs / omni / bwc / chab / etc...
      channel: "secure", // select one of the following: secure | public
      page_type: "application"
    };
  };

  cleanSearchParams(url: string): string {
    const parseUrl = new URL(url);
    parseUrl.search = "";
    return parseUrl.toString();
  }

  sendGtmPageView(data: GA4View, appendix = ""): void {
    data.page_location = `${this.cleanSearchParams(this.href)}/${appendix}`;
    data.page_language = this.translateService.defaultLang;
    data.content_group = `${this.getLob()} : ${this.productService.chnl.toLowerCase()}`;
    data.event = "page_view";
    (window as any).dataLayer.push({
      ...data,
      ...this.defaultProps()
    });
  }

  sendGABeginCheckoutEvent(pageEventDetail: PageEventDetails) {
    const gaEcommerce: Ecommerce = this.updateEcommerceDetailForGAEvent(pageEventDetail.cardType);
    const data: GABegin = {
      event: "begin_checkout",
      funnel_details: pageEventDetail.product.toLowerCase(),
      step_number: GAPageMapping[pageEventDetail.pageName].stepNumber,
      step_name: GAPageMapping[pageEventDetail.pageName].stepName,
      ecommerce: gaEcommerce
    };
    this.setEcommerceToNull();
    (window as any).dataLayer.push({
      ...data
    });
  }

  sendGAProgressCheckoutEvent(pageEventDetail: PageEventDetails): void {
    const data: GAStepDetails = {
      event: "progress_checkout",
      funnel_details: pageEventDetail.product.toLowerCase(),
      step_number: GAPageMapping[pageEventDetail.pageName].stepNumber,
      step_name: GAPageMapping[pageEventDetail.pageName].stepName
    };
    this.setEcommerceToNull();
    (window as any).dataLayer.push({
      ...data
    });
  }

  updateEcommerceDetailForGAEvent(cardType: string): Ecommerce {
    let item: Ecommerce = {
      value: 0,
      items: [{ item_id: "", item_name: "", item_category: "", item_category2: "", price: 0, quantity: 1 }]
    };
    item = GACardMapping[cardType.toUpperCase()];
    return item;
  }

  setEcommerceToNull() {
    (window as any).dataLayer.push({ ecommerce: null });
  }
}
